// @flow

import React from 'react';
import {Button, Callout, Card, Intent} from "@blueprintjs/core";
import Flexbox from "flexbox-react";
import styles from "./ErrorBoundary.module.css";

type Props = {
    children: React$Node,
    message?: string,
};

type State = {
    hasError: boolean,
};

export default class ErrorBoundary extends React.Component<Props, State> {
    state = {hasError: false};

    static getDerivedStateFromError() {
        return {hasError: true};
    }

    componentDidCatch(error: Error, info: {componentStack: string}) {
        console.error("ErrorBoundary caught a render error:", error, info.componentStack);
    }

    render() {
        if (this.state.hasError) {
            return (
                <Flexbox className={styles.errorScreen} justifyContent={'center'} alignItems={'center'}>
                    <Card elevation={2} className={styles.errorCard}>
                        <Callout title={'Something went wrong'} intent={Intent.DANGER}>
                            <p>{this.props.message || "This part of the app hit an unexpected error. Reloading the page usually fixes it."}</p>
                            <Button text={'Reload'} intent={Intent.DANGER} onClick={() => window.location.reload()}/>
                        </Callout>
                    </Card>
                </Flexbox>
            );
        }
        return this.props.children;
    }
}
